import styles from './BgOrangeBlur.module.scss'


const BgOrangeBlur: React.FC = () => {
    return (
    <div className={styles.container}></div>
    )
}
export default BgOrangeBlur